import React, { useRef, useState, useEffect } from "react";
import { Box, LinearProgress, Tooltip } from "@mui/material";
import { Ptag } from "components/core";

function LinearProgressComponent({ value, label, total }) {
  const textRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const checkTruncation = () => {
      const node = textRef.current;
      if (node) {
        setShowTooltip(node.scrollWidth > node.clientWidth);
      }
    };

    checkTruncation();
    window.addEventListener("resize", checkTruncation); // Update on window resize

    return () => {
      window.removeEventListener("resize", checkTruncation); // Clean up listener
    };
  }, []);

  return (
    <Box>
      {(label || total) && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 1,
            marginRight: "0.2rem",
          }}
        >
          {label && (
            <Tooltip
              title={
                <Ptag
                  fontWeight="400"
                  textTransform="capitalize"
                  color="white"
                >
                  {capitalizeText(label)}
                </Ptag>
              }
              placement="top"
              arrow
              disableHoverListener={!showTooltip}
            >
              <Ptag
                ref={textRef}
                fontWeight="400"
                textTransform="capitalize"
                className="truncate-hover-progressbar"
                style={{
                  maxWidth: "70%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontFamily: "Montserrat",
                  fontWeight: "500",
                  fontSize: "12px",
                }}
              >
                {capitalizeText(label)}
              </Ptag>
            </Tooltip>
          )}
          {total && <Ptag fontWeight="500" fontFamily="Montserrat" fontSize="12px">{total}</Ptag>}
        </Box>
      )}
      <LinearProgress
        variant="determinate"
        value={value}
        sx={{
          height: 5,
          borderRadius: 5,
          "& .MuiLinearProgress-bar": {
            borderRadius: 5,
            backgroundColor: "#18181B",
          },
          backgroundColor: (theme) =>
            theme.palette.grey[theme.palette.mode === "light" ? 200 : 700],
        }}
      />
    </Box>
  );
}

export default LinearProgressComponent;

function capitalizeText(text) {
  return text.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
}
